import React, { memo } from 'react';

const OperatorInner = () => (
    <svg viewBox="0 0 20 18">
        <path d="M10.2615 4V1C10.2615 0.447715 9.81382 0 9.26154 0H1.87692C1.32464 0 0.876923 0.447715 0.876923 1V17C0.876923 17.5523 1.32464 18 1.87692 18H18.6462C19.1984 18 19.6462 17.5523 19.6462 17V5C19.6462 4.44772 19.1984 4 18.6462 4H10.2615ZM4.63077 16H2.75385V14H4.63077V16ZM4.63077 12H2.75385V10H4.63077V12ZM4.63077 8H2.75385V6H4.63077V8ZM4.63077 4H2.75385V2H4.63077V4ZM8.38462 16H6.50769V14H8.38462V16ZM8.38462 12H6.50769V10H8.38462V12ZM8.38462 8H6.50769V6H8.38462V8ZM8.38462 4H6.50769V2H8.38462V4ZM17.7692 16H10.2615V14H12.1385V12H10.2615V10H12.1385V8H10.2615V6H17.7692V16ZM15.8923 8H14.0154V10H15.8923V8ZM15.8923 12H14.0154V14H15.8923V12Z" />
    </svg>
);

export const Operator = memo(OperatorInner);
